import React from 'react';
import TextWinds from '../common/TextWinds';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';

const CourseNaviBar = () => {
  return (
    <div className="xl:py[50px] relative flex w-full items-center justify-between rounded-none bg-gradient-to-r from-gradient_f to-gradient_t px-[20px] py-[26px] xl:mb-[100px] xl:justify-between xl:bg-spotLilac xl:from-transparent xl:to-transparent xl:px-[72px]">
      <div className="relative inline-flex hidden flex-auto flex-col items-start xl:block">
        <TextWinds type="title_h1" color="white">
          젭스의 전체 코스
        </TextWinds>
        <TextWinds type="content_body4" color="white" className="pt-[10px]">
          영어교실부터 주일학교, NIV학습까지!
          <br />
          나에게 필요한 젭스 코스가 무엇인지 확인해 보세요.
        </TextWinds>
      </div>
      <div className="relative inline-flex w-full cursor-pointer flex-col items-end justify-end xl:w-[280px]">
        <div className="relative flex flex-auto items-start justify-between self-stretch rounded-md bg-white px-[12px] py-[14px] xl:p-[24px]">
          <div className="relative">
            <Link to={'/courses'}>
              <TextWinds type="content_bold">
                젭스의 다른 코스를 보고 싶다면?
              </TextWinds>
              <div className="gap-[2px]] inline-flex flex-auto items-center">
                <TextWinds type="content_bold" color="purple5">
                  코스 찾기 이동
                </TextWinds>
                <ArrowRightIcon className="h-[20px] w-[20px]" color="purple" />
              </div>
            </Link>
          </div>
          <Link to={'/courses'}>
            <img
              className="h-[52px] w-[52px]"
              src={process.env.PUBLIC_URL + '/images/course/findcourse.png'}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CourseNaviBar;
